import userInstance from "../Instance/userInstance"

export const GetAccessToken = async (body) => {
    const res = await userInstance.post("GetAccessToken", body)
    return res
}